import type { Catalog } from '@smarton-pbx/shared';

export const insights: Catalog = {
  // Dashboard.
  '{h} h {m} min': '{h} val. {m} min.',
  'Week of {date}': 'Savaitė nuo {date}',
  'Last 7 days': 'Paskutinės 7 dienos',
  'Last 30 days': 'Paskutinės 30 dienų',
  'Last 8 weeks': 'Paskutinės 8 savaitės',
  'Last 26 weeks': 'Paskutinės 26 savaitės',
  'Your calls, by day or week.': 'Jūsų skambučiai pagal dienas ar savaites.',
  'Calls per person in your region.': 'Skambučiai pagal darbuotojus jūsų regione.',
  'Calls per person, across regions.': 'Skambučiai pagal darbuotojus visuose regionuose.',
  'Group by': 'Grupuoti',
  'By day': 'Pagal dienas',
  'By week': 'Pagal savaites',
  Period: 'Laikotarpis',
  'Times in {zone}': 'Laiko juosta: {zone}',
  'Calls per day': 'Skambučiai per dieną',
  'Calls per week': 'Skambučiai per savaitę',
  'No calls in this period.': 'Per šį laikotarpį skambučių nebuvo.',
  '{period}: {incoming} incoming, {outgoing} outgoing, {missed} missed': '{period}: įeinančių {incoming}, išeinančių {outgoing}, praleistų {missed}',
  // Counts of calls (tiles and columns), not one call's direction or outcome.
  'count|Incoming': 'Įeinantys',
  'count|Outgoing': 'Išeinantys',
  'count|Answered': 'Atsiliepti',
  'count|Missed': 'Praleisti',
  Person: 'Darbuotojas',
  'Talk time': 'Pokalbių trukmė',
  'Their calls': 'Darbuotojo skambučiai',

  // Insights.
  'Nothing yet in this period.': 'Per šį laikotarpį dar nieko nėra.',
  'See these calls': 'Rodyti šiuos skambučius',
  'What the AI reviews of your sales calls add up to.': 'Ką rodo jūsų pardavimo skambučių DI vertinimai.',
  'Why sales are lost, what customers object to, and how each person is doing.':
    'Kodėl prarandami pardavimai, kam prieštarauja klientai ir kaip sekasi kiekvienam darbuotojui.',
  'Last 90 days': 'Paskutinės 90 dienų',
  'Last year': 'Paskutiniai metai',
  'From AI reviews: guesses, corrected by people where they knew better.': 'Pagal DI vertinimus: tai spėjimai, kuriuos žmonės pataisė, kur žinojo geriau.',
  'No reviewed sales calls yet': 'Įvertintų pardavimo skambučių dar nėra',
  'Once AI review is on (Settings → AI call review), sales calls are reviewed after they are transcribed.':
    'Kai DI vertinimas įjungtas („Nustatymai“ → „DI pokalbių vertinimas“), pardavimo skambučiai įvertinami, kai tik transkribuojami.',
  'Reviewed sales calls': 'Įvertinti pardavimo skambučiai',
  'Why sales are lost': 'Kodėl prarandami pardavimai',
  Objections: 'Prieštaravimai',
  'Competitors named': 'Paminėti konkurentai',
  You: 'Jūs',
  Reviewed: 'Įvertinta',
  Sales: 'Pardavimai',
  'Share of the talking done by the salesperson': 'Kokią pokalbio dalį kalbėjo pardavėjas',
  'Talk share': 'Kalbėjimo dalis',
  Trend: 'Tendencija',
  'Longest stretch without letting the customer speak': 'Ilgiausiai kalbėta neleidžiant klientui prabilti',
  'Longest monologue': 'Ilgiausias monologas',
  'Questions per call': 'Klausimai per skambutį',
  'Coaching points': 'Patarimai',
  'Weekly digests': 'Savaitės apžvalgos',
  'Week of {date}: {about}': 'Savaitė nuo {date}: {about}',
  Team: 'Komandos',
  Personal: 'Asmeninė',
  'Team digest: {about}, from {calls}. Coaching, not grading.': 'Komandos apžvalga: {about}, pagal {calls}. Skirta mokymui, ne vertinimui.',
  'Your digest, from {calls}. Coaching, not grading.': 'Jūsų apžvalga pagal {calls}. Skirta mokymui, ne vertinimui.',
  '{n} reviewed sales calls': {
    one: '{n} įvertintą pardavimo skambutį',
    few: '{n} įvertintus pardavimo skambučius',
    other: '{n} įvertintų pardavimo skambučių',
  },
  'Going well': 'Kas sekasi gerai',
  'To improve': 'Ką tobulinti',
  'Written by AI ({model}) from the week’s reviews.': 'Parengė DI ({model}) pagal savaitės vertinimus.',
};
